import { useParams } from '@tanstack/react-router';

import PermitProcessGuide from './permit-process-guide/PermitProcessGuide';
import Jurisdiction from './Jurisdiction/Jurisdiction';
import Permitting from './Permitting/Permitting';
import PublicNotices from './PublicNotices';
import Mitigation from './Mitigation';
import OverviewResources from './OverviewResources/OverviewResources';
import Announcements from './Announcements';

import '../resources.scss';
import SideNavigation from '@components/side-navigation/SideNavigation';

const headerText = {
  jurisdiction: 'Jurisdiction',
  mitigation: 'Mitigation',
  'permit-process-guide': 'Permit Process Guide',
  permitting: 'Permitting',
  'public-notices': 'Public Notices',
  'regulatory-announcements': 'Regulatory Announcements',
  'regulatory-program': 'Regulatory Program Information',
};

const content = {
  jurisdiction: <Jurisdiction />,
  mitigation: <Mitigation />,
  'permit-process-guide': <PermitProcessGuide />,
  permitting: <Permitting />,
  'public-notices': <PublicNotices />,
  'regulatory-announcements': <Announcements />,
  'regulatory-program': <OverviewResources />,
};

const linkProps = [
  { label: 'Regulatory Program Information', href: '/home/regulatory-program' },
  { label: 'Permit Process Guide', href: '/home/permit-process-guide' },
  { label: 'Jurisdiction', href: '/home/jurisdiction' },
  {
    label: 'Permitting',
    href: '/home/permitting',
    subSections: [
      { label: 'Joint Permit Application Process', href: '/home/permitting#jpa-id', id: 'clean-water-act-id' },
    ],
  },
  { label: 'Public Notices', href: '/home/public-notices' },
  { label: 'Regulatory Announcements', href: '/home/regulatory-announcements' },
  { label: 'Mitigation', href: '/home/mitigation' },
];

const ResourcesContent = () => {
  const { resource } = useParams({ from: '/home/$resource' });

  return (
    <div className='content-container'>
            <h1>{headerText[resource] || ''}</h1>
            <SideNavigation items={linkProps}>{content[resource] || null}</SideNavigation>
          
    </div>
  );
};

export default ResourcesContent;
